import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Carousel, ConfigProvider } from "antd";
import { Box } from "@mui/material";

import "./landingContent.css";
import BrandIcons from "./brandIcons";
import AdvanceFilter from "./advanceFilter";
import PopularCarSection from "./popularCarSection";
import AffordableCarSection from "./affordableCarSection";
import BusinessPartners from "./businessPartners";
import ReviewSection from "./reviewSection";

const carouselData = [
  {
    id: 1,
    desktopImage: "carousel/adminbanner.jpg",
    mobileImage: "carousel/car1.jpg",
    route: "/seeallPopularCarModels",
  },
  {
    id: 2,
    desktopImage: "carousel/amarcarbanner1.jpg",
    mobileImage: "carousel/car2.jpg",
    route: "/seeallAffordableCarModels",
  },
  {
    id: 3,
    desktopImage: "carousel/amarcarbanner2.jpg",
    mobileImage: "carousel/car3.jpg",
    route: "/seeallAffordableCarModels",
  },
  {
    id: 4,
    desktopImage: "carousel/adminbanner.jpg",
    mobileImage: "carousel/car1.jpg",
    route: "/seeallPopularCarModels",
  },
  {
    id: 5,
    desktopImage: "carousel/amarcarbanner1.jpg",
    mobileImage: "carousel/car2.jpg",
    route: "/seeallAffordableCarModels",
  },
];

const LandingContent = () => {
  const navigate = useNavigate();
  const carouselRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handlePrevClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (carouselRef.current) {
      carouselRef.current.prev();
    }
  };

  const handleNextClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  return (
    <Box>
      <ConfigProvider
        theme={{
          components: {
            Carousel: {
              dotWidth: 24,
              dotActiveWidth: 40,
              dotHeight: 4,
            },
          },
        }}
      >
        {/* ================= Carousel Container ================= */}
        <div className="carousel-wrapper">
          <Carousel
            ref={carouselRef}
            autoplay
            effect="slide"
            autoplaySpeed={5000}
            dots={true}
            arrows={false}
          >
            {carouselData.map((slide) => (
              <div key={slide.id} className="carousel-slide-container">
                <img
                  src={isMobile ? slide.mobileImage : slide.desktopImage}
                  alt="carousel slide"
                  className="carousel-image"
                  onClick={() => navigate(slide.route)}
                />
              </div>
            ))}
          </Carousel>

          {/* Left Arrow Button */}
          <button
            className="carousel-nav-btn carousel-nav-left"
            onClick={handlePrevClick}
            onMouseDown={(e) => e.preventDefault()}
            aria-label="Previous slide"
            type="button"
          >
            <span className="arrow-icon">&#10094;</span>
          </button>

          {/* Right Arrow Button */}
          <button
            className="carousel-nav-btn carousel-nav-right"
            onClick={handleNextClick}
            onMouseDown={(e) => e.preventDefault()}
            aria-label="Next slide"
            type="button"
          >
            <span className="arrow-icon">&#10095;</span>
          </button>
        </div>
      </ConfigProvider>

      {/* ================= Page Sections ================= */}
      <BrandIcons />

      <Box>
        <PopularCarSection />
      </Box>

      <Box>
        <AffordableCarSection />
      </Box>

      <AdvanceFilter />

      <ReviewSection />

    </Box>
  );
};

export default LandingContent;